export default __webpack_public_path__ + "static/media/Sidewalk_Shade.c5517064.mp3";